import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useInvoicesList() {
  // Use toast
  const toast = useToast()
  const refInvoiceCollectionListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { label: '#', key: 'id', sortable: true },
    { label: 'Bedrijf', key: 'companyName', sortable: true },
    { label: 'Datum', key: 'timestamp', sortable: true },
    { label: 'Status', key: 'status', sortable: true },
    { label: 'Bedrag excl. BTW', key: 'subAmount', sortable: true },
    { label: 'BTW', key: 'vatAmount', sortable: true },
    { label: 'Totaal', key: 'totalAmount', sortable: true },
    { label: 'Acties', key: 'actions', sortable: false },
  ]
  const perPage = ref(25)
  const totalInvoiceCollections = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const sortBy = ref('timestamp')
  const isSortDirDesc = ref(false)
  const statusFilter = ref(null)
  const showOverlay = ref(false)
  const searchQuery = ref('')

  const dataMeta = computed(() => {
    const localItemsCount = refInvoiceCollectionListTable.value ? refInvoiceCollectionListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalInvoiceCollections.value,
    }
  })

  const refetchData = () => {
    refInvoiceCollectionListTable.value.refresh()
  }

  watch([currentPage, perPage, statusFilter, searchQuery], () => {
    refetchData()
  })

  const fetchInvoiceCollections = (ctx, callback) => {
    store
      .dispatch('app-invoice-collection/fetchInvoiceCollections', {
        perPage: perPage.value,
        page: currentPage.value,
        sortDesc: isSortDirDesc.value,
        sortBy: sortBy.value,
        status: statusFilter.value,
      })
      .then(response => {
        const { items, _meta } = response.data

        callback(items)
        showOverlay.value = false
        totalInvoiceCollections.value = _meta.total
      })
      .catch(() => {
        showOverlay.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Ophalen facturen',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: 'Er is een fout opgetreden bij het ophalen van de data. Probeer het nogmaals.',
          },
        })
      })
  }

  const resolveTypeVariant = status => {
    if (status === 10) return { status: 'Open', variant: 'warning' }
    if (status === 20) return { status: 'Betaald', variant: 'success' }
    return { status: '', variant: '' }
  }

  const statusOptions = [
    { label: 'Niet betaald', value: 1 },
    { label: 'Betaald', value: 2 },
  ]

  return {
    tableColumns,
    perPage,
    currentPage,
    totalInvoiceCollections,
    dataMeta,
    perPageOptions,
    sortBy,
    refInvoiceCollectionListTable,
    statusFilter,
    resolveTypeVariant,
    statusOptions,
    refetchData,
    showOverlay,
    isSortDirDesc,
    searchQuery,
    fetchInvoiceCollections,
  }
}
